import React, { useState } from 'react';

const faqs = [
  {
    question: 'Wat is een freelance contract in België?',
    answer: 'Een freelance contract in België is een juridisch bindende overeenkomst tussen een zelfstandige (freelancer) en een opdrachtgever. Het legt alle afspraken vast over de opdracht, vergoeding, deadlines en aansprakelijkheid. In België wordt dit ook wel een "aannemingsovereenkomst" of "overeenkomst van opdracht" genoemd, geregeld door het Belgisch Burgerlijk Wetboek.',
  },
  {
    question: 'Heb ik een ondernemingsnummer nodig als freelancer in België?',
    answer: 'Ja, als freelancer in België moet je ingeschreven zijn bij de Kruispuntbank van Ondernemingen (KBO) en beschik je over een ondernemingsnummer (BE + 10 cijfers). Dit nummer moet vermeld worden op al je facturen en contracten. Zonder ondernemingsnummer mag je in België niet legaal als zelfstandige werken.',
  },
  {
    question: 'Welk recht is van toepassing op freelance contracten in België?',
    answer: 'Op freelance contracten in België is het Belgisch recht van toepassing, meer bepaald het Belgisch Burgerlijk Wetboek (nieuw BW, in werking getreden op 1 januari 2023). Bij geschillen zijn de Belgische rechtbanken bevoegd. Partijen kunnen in het contract een specifieke bevoegde rechtbank aanduiden.',
  },
  {
    question: 'Is een freelance contract verplicht in België?',
    answer: 'Een schriftelijk freelance contract is niet wettelijk verplicht in België, maar het is sterk aanbevolen. Zonder contract is het moeilijk om afspraken te bewijzen bij een geschil. Bovendien vereisen veel Belgische bedrijven een ondertekend contract voordat ze met een freelancer samenwerken. Een contract beschermt ook je zelfstandige status.',
  },
  {
    question: 'Kan ik een gratis freelance contract template gebruiken in België?',
    answer: 'Ja, met Pactorae kun je gratis een professioneel freelance contract genereren dat is afgestemd op de Belgische wetgeving. De generator verwerkt automatisch je ondernemingsnummer, btw-nummer en de correcte Belgische juridische bepalingen. In 30 seconden heb je een contract op maat.',
  },
];

const FaqItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-[#2F4E6F] pr-4">{faq?.question}</span>
        <span
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-200"
          style={{ backgroundColor: '#FF8C00', transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

const BelgiumFaq = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Veelgestelde vragen over freelance contracten in België</h2>
    <div className="space-y-3">
      {faqs?.map((faq, i) => (
        <FaqItem key={i} faq={faq} />
      ))}
    </div>
  </section>
);

export default BelgiumFaq;
